












import Vue from "vue";

import PageTitle from "@/components/common/PageTitle.vue";

export default Vue.extend({
  name: "page404",
  components: { PageTitle },
});
